import UniversalCookies from 'universal-cookie';
import { useRouter } from 'next/router';

import { LOCALE, cookies, INTL_LOCALE } from '@/data/constants';
import { isPharmaprixBanner } from '@/utils';

const isPharmaprix = typeof window !== 'undefined' ? isPharmaprixBanner() : null;
const { USER_PREFERRED_LOCALE, SDM_LANG, CONTENTFUL_SDM_LANG_CODE } = cookies;
const cookieStore = new UniversalCookies();

const setPreferredLanguage = (lang: string) => {
  const { EN, FR, EN_QC, FR_QC } = INTL_LOCALE;

  let sdmLang;
  if (isPharmaprix) {
    sdmLang = lang === LOCALE.EN ? EN_QC : FR_QC;
  } else {
    sdmLang = lang === LOCALE.EN ? EN : FR;
  }

  cookieStore.set(USER_PREFERRED_LOCALE, lang, {
    path: '/',
  });
  // The following two cookies are for SDM.ca pages
  const encodedSDMLang = encodeURIComponent(SDM_LANG);
  cookieStore.set(encodedSDMLang, sdmLang, {
    path: '/',
  });
  cookieStore.set(CONTENTFUL_SDM_LANG_CODE, sdmLang, {
    path: '/',
  });
};

export const useDetermineLocale = (): ValueOf<typeof LOCALE> => {
  const { EN, FR } = LOCALE;
  const {
    query: { lang },
  } = useRouter();

  if (lang === EN || lang === FR) {
    setPreferredLanguage(lang);
    return lang;
  }

  const preferredLanguage = cookieStore.get(USER_PREFERRED_LOCALE);
  const defaultLanguage = isPharmaprix ? FR : EN;

  const islanguageCookieSet = !!cookieStore.get(SDM_LANG) && !!cookieStore.get(CONTENTFUL_SDM_LANG_CODE);

  if (preferredLanguage === EN || preferredLanguage === FR) {
    if (!islanguageCookieSet) {
      setPreferredLanguage(preferredLanguage);
    }
    return preferredLanguage;
  } else {
    setPreferredLanguage(defaultLanguage);
    return defaultLanguage;
  }
};
